/**
 * Left/Right arrow navigation in the document image gallery (HS2-2NB74E). Returns the
 * step to take (-1 previous, 1 next) or null when the key belongs to something else:
 * a modified key, a handled event, typing in a field, a focused annotation pin (arrows
 * move the pin), or an open menu (arrows move through its items).
 */
export function galleryArrowStep(
  event: Pick<KeyboardEvent, 'key' | 'defaultPrevented' | 'altKey' | 'ctrlKey' | 'metaKey' | 'shiftKey' | 'target'>,
): -1 | 1 | null {
  if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return null;
  if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return null;
  if (keepsArrowKeys(event.target)) return null;
  return event.key === 'ArrowLeft' ? -1 : 1;
}

const ARROW_KEY_OWNERS = [
  'input',
  'textarea',
  'select',
  '[contenteditable]:not([contenteditable="false"])',
  'kui-select',
  '[data-document-annotation-marker]',
  '.kui-popup-menu',
  '[role="menu"]',
  '[role="menuitem"]',
].join(', ');

function keepsArrowKeys(target: EventTarget | null): boolean {
  const closest = (target as Partial<Pick<Element, 'closest'>> | null)?.closest;
  return typeof closest === 'function' && closest.call(target, ARROW_KEY_OWNERS) !== null;
}
